<template>
  <div>
    <button
      type="button"
      class="stat limit cursor-pointer building-passes-trigger border-0"
      aria-label="Open building passes limit modal"
      @click="openModal"
    >
      Building Passes
      <span class="d-flex flex-column">
        {{ allActivePassesLength }}
        / {{ totalPassesLength }}
        <b class="limit-count">Limit - {{ activePassLimit }}</b>
      </span>
    </button>
    <CModal
      id="building-passes-limit-modal"
      ref="limitActivePassModalRef"
      backdrop="static"
      :visible="state.isModalVisible"
      :unmount-on-close="false"
      :close-on-backdrop="false"
    >
      <div
        class="pt-4 px-4 create-popup-header d-flex align-items-center justify-content-between"
      >
        <HelpCenterButton
          content-key="limit_acive_passes_pop_up"
          :is-old="true"
        />
        <div class="text-end close-btn">
          <button
            type="button"
            class="close-modal-action btn btn-link p-0 border-0 building-passes-modal-close-btn"
            aria-label="Close building passes limit modal"
            @click="closeModal"
          >
            <i class="ri-close-line cursor-pointer" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div class="px-3">
        <h2 class="mb-4 text-center">Limit Active Passes</h2>
        <LimitActivePassForm
          ref="CreateLimitActivePassForm"
          @close-modal="closeModal"
        />
      </div>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import { reactive, computed, ref } from "vue"
import { useStore } from "vuex"
import LimitActivePassForm from "@/v3components/Forms/LimitActivePassForm.vue"
import HelpCenterButton from "@/v3components/HelpCenterButton.vue"
import useLegacyModalFocusTrap from "@/composables/useLegacyModalFocusTrap"

export default {
  name: "BuildingPassesOld",
  components: {
    LimitActivePassForm,
    HelpCenterButton
  },
  setup() {
    const store = useStore()
    const limitActivePassModalRef = ref(null)

    const state = reactive({
      isModalVisible: false
    })

    const activePassLimits = computed(() => {
      return store.getters["activePass/activePassLimits"]
    })

    const totalPassesLength = computed(() => {
      return store.getters["dashboardCounters/totalPassesLength"]
    })

    const allActivePassesLength = computed(() => {
      return store.getters["dashboardCounters/allActivePassesLength"]
    })

    const activePassLimit = computed(() => {
      return activePassLimits.value !== null &&
        activePassLimits.value.limit !== "-"
        ? activePassLimits.value.limit
        : ""
    })

    const openModal = () => {
      state.isModalVisible = true
    }

    const closeModal = () => {
      state.isModalVisible = false
    }

    useLegacyModalFocusTrap(
      "building-passes-limit-modal",
      computed(() => state.isModalVisible),
      closeModal,
      () => {
        const refElement = limitActivePassModalRef.value?.$el
        if (!refElement) return null
        if (refElement.classList?.contains("modal")) return refElement
        return refElement.querySelector?.(".modal")
      }
    )

    return {
      state,
      limitActivePassModalRef,
      activePassLimits,
      totalPassesLength,
      allActivePassesLength,
      activePassLimit,
      openModal,
      closeModal
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/v3scss/_variables.scss";

.building-passes-trigger {
  border-radius: 8px;
}

.building-passes-trigger:focus-visible {
  outline: 2px solid $outline-color;
  outline-offset: 2px;
}

.building-passes-modal-close-btn:focus-visible {
  outline: 2px solid $outline-color;
  outline-offset: $outline-offset;
}
</style>
